import React from "react";
import "./MCType.css";
import MCimage1 from "../../../assets/mctypefull.jpg";
 
export default function MCType() {
  return (
    <div className="MC-Type-1-box-2-snaithe-main-info">
      <div className="MC-Type-1-image-container-right-1-3-custom">
        <img src={MCimage1} alt="Square Image" />
      </div>
      <div className="MC-Type-1-text-container-3-custom">
        <div className="MC-Type-1-title-3-custom">MCType.com</div>
        <h2 className="MC-Type-1-box3-second-titles-3-custom">
          The Essence Within Every Rev{" "}
        </h2>
        <div className="MC-Type-1-text-3-custom1">
          MCType.com isn't merely a platform; it's a haven dedicated to the
          symphony of mechanized marvels. Envision an arena where the thrill of
          acceleration converges with the precision of artistry. Our
          meticulously curated collection of motorcycles, bicycles, and e-bikes
          transcends a mere catalog; it's an anthology of mechanical poesy.
          <br></br>
          <br></br>
          Immerse yourself in intricate specifications, decode performance
          subtleties, and embrace a narrative where each ride unfurls a unique
          tale. MCType.com extends an invitation to a world where trust isn't
          just earned; it's etched into every curve and resonates in every rev.
          <br></br>
          <br></br>• An extensive selection encompassing motorcycles, bicycles,
          and e-bikes.
          <br></br>• Comprehensive specifications and nuanced performance data
          accompanying each vehicle.
          <br></br>• Personalization options for tailoring vehicles to
          individual preferences.
          <br></br>• User-friendly interface facilitating effortless exploration
          and selection.
        </div>
      </div>
    </div>
  );
}
